import React, { useContext } from 'react';

import { updateTaskSubObjectiveAction } from 'actions/task';
import ObjectiveTreeView, { ObjectiveDisplayContext } from 'screens/home/tasksList/ObjectiveTreeView';
import styled from 'styled-components';
import { StyledTooltip, NewStyledIconButton } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { TargetIcon } from 'constants/icons';

const Container = styled(NewStyledIconButton)`
  height: 22px;
  width: 22px;
  border: 1px solid ${(props) => getColorFromKey(props.color || props.theme.palette.text.secondary)};
  background-color: white;
  svg {
    fill: #999;
  }
  &:hover {
    border-color: ${getColorFromKey('primary')};
    svg {
      fill: ${getColorFromKey('primary')};
    }
  }
`;

export default function TaskObjectiveEditComponent({ taskId, taskKey, selectedSubObjective, dispatch }) {
  function onObjectiveChange(tag) {
    dispatch(updateTaskSubObjectiveAction({ taskId, key: taskKey, subObjective: tag }));
  }
  return (
    <ObjectiveTreeView
      onObjectiveChange={onObjectiveChange}
      renderObjectiveDisplay={() => (
        <ObjectiveDisplay
          color={selectedSubObjective ? 'primary' : 'textSecondary'}
          tooltip={selectedSubObjective?.displayName || 'Add objective'}
        />
      )}
    />
  );
}

function ObjectiveDisplay({ color, tooltip }) {
  const { onClick, buttonRef } = useContext(ObjectiveDisplayContext);
  // Using extra div and span because ref doesn't work properly with icon and tooltip, even after using forwardref
  return (
    <div ref={buttonRef} onClick={onClick}>
      <StyledTooltip title={tooltip}>
        <span>
          <Container color="#999" circular>
            <TargetIcon color={color} size="tinier" />
          </Container>
        </span>
      </StyledTooltip>
    </div>
  );
}
